import {
  IMobilityPlannerRepository,
  IUpdateDrive,
  MobilityPlannerParams,
} from '@common/interfaces';
import AxiosRepository from './axios.repository';

class MobilityPlannerRepository extends AxiosRepository implements IMobilityPlannerRepository {
  private static buildParams(params?: MobilityPlannerParams) {
    const searchParams = new URLSearchParams();

    if (params?.agencyId) searchParams.append('agency_id', params.agencyId);
    if (params?.date) searchParams.append('date', params.date);
    if (params?.isTemporary) searchParams.append('is_temporary', params.isTemporary);

    return searchParams;
  }

  async getDrives(facilityId: string, params?: MobilityPlannerParams) {
    const searchParams = MobilityPlannerRepository.buildParams(params);
    const { data } = await this.get(`/facilities/${facilityId}/planner/drives/?${searchParams}`);

    return data;
  }

  async getVehicles(facilityId: string, params?: MobilityPlannerParams) {
    const searchParams = MobilityPlannerRepository.buildParams(params);
    const { data } = await this.get(`/facilities/${facilityId}/planner/vehicles/?${searchParams}`);

    return data;
  }

  async updateDrive(facilityId: string, bookingId: string, drives: IUpdateDrive[]) {
    const { data } = await this.patch(
      `/facilities/${facilityId}/planner/booking-form/processed/${bookingId}/`,
      { drives },
    );

    return data;
  }
}

export default MobilityPlannerRepository;
